import React from 'react';
import { motion } from 'framer-motion';
import { LockIcon, ZapIcon, ShieldCheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { Eyebrow } from './Eyebrow';
import { PRICE, PRICE_PLN } from '../data/valueStack';
const highlights = ['Teoria + 50 ćwiczeń jazzowych', '6 kompletnych tomów', '6 darmowych bonusów', 'Pełna część teoretyczna', '100% PDF · Drukuj i ucz'];
const assurances = [{
  icon: LockIcon,
  label: 'Bezpieczna płatność'
}, {
  icon: ZapIcon,
  label: 'Natychmiastowy dostęp'
}, {
  icon: ShieldCheckIcon,
  label: '10 dni gwarancji'
}];
export function Hero() {
  return <header id="top" className="bg-night" data-id="element-179" data-mp="s9zzhikkb8n9">
      <div className="mx-auto max-w-shell px-5 pb-12 pt-12 sm:px-6 sm:pb-16 sm:pt-16" data-id="element-180" data-mp="sd4bv386lap0">
        <motion.div initial={{
        opacity: 0,
        y: 14
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto max-w-4xl text-center" data-id="element-181" data-mp="neauv0tor1k3">
          <Eyebrow align="center" data-id="element-182" data-mp="3j8sg632wlnqw">Kompletna metoda dla nauczycieli gitary jazzowej</Eyebrow>
          <h1 className="mt-6 font-display text-[2.6rem] leading-[0.95] sm:text-7xl lg:text-8xl" data-id="element-183" data-mp="3o7c1q2dl4xiq">
            <span className="block text-cream" data-id="element-184" data-mp="39alaige2es47">Zorganizuj cały swój</span>
            <span className="block text-amber" data-id="element-185" data-mp="39cfkx0rpn1u1">semestr jazzu z tym pakietem</span>
          </h1>
          <p className="mx-auto mt-6 max-w-2xl font-serif text-lg italic leading-relaxed text-cream-soft sm:text-2xl" data-id="element-186" data-mp="3ebiqcmblra2j">
            System &bdquo;Drukuj i ucz&rdquo; dla nauczycieli gitary jazzowej, który zmienia
            planowanie lekcji z <span className="text-amber" data-id="element-187" data-mp="2qk3i6cx59yjd">chaotycznego</span> w{' '}
            <span className="text-cream" data-id="element-188" data-mp="2qhqvxnkct20i">oczywiste</span>.
          </p>
        </motion.div>
        <div className="relative mx-auto mt-10 max-w-5xl sm:mt-12" data-id="element-189" data-mp="2vj7wfhyxemgk">
          <span className="absolute -top-3.5 right-4 z-10 rounded-full bg-amber px-3.5 py-1.5 text-[10px] font-bold uppercase tracking-[0.14em] text-night sm:-top-4 sm:right-6 sm:px-4 sm:text-xs" data-id="element-190" data-mp="2hk87sabey7ke">
            6 tomów + 6 bonusów
          </span>
          <div className="rounded-2xl border border-night-600 bg-night-800 p-2 sm:p-3" data-id="element-191" data-mp="s3us1zznrec7">
            <img src="https://cdn.magicpatterns.com/uploads/vL3a7ZezmJRFuApQTcxmoi/Imagen_de_ChatGPT_30_sept_2026,_12_18_55_p.m..png" alt="Kompletny Arsenał Nauczyciela Jazzu: sześć podręczników oraz kurs na komputerze, tablecie i telefonie" className="w-full rounded-xl" data-id="element-192" data-mp="n98epra0nbph" />
          </div>
        </div>
        <ul className="mx-auto mt-10 flex max-w-3xl flex-wrap justify-center gap-x-5 gap-y-2 sm:gap-x-7" data-id="element-193" data-mp="162udyzvsdf4o">
          {highlights.map(item => <li key={item} className="text-[10px] font-semibold uppercase tracking-label text-cream-muted sm:text-[11px]" data-id="element-194" data-mp="114kispa2aej2">
              {item}
            </li>)}
        </ul>
        <div className="mt-8 flex flex-col items-center gap-3" data-id="element-195" data-mp="3hrlkwjixk99i">
          <CtaButton size="lg" target="offer" data-id="element-196" data-mp="3htg864hocdgr">
            Zdobądź Arsenał teraz
          </CtaButton>
          <p className="text-center text-xs text-amber-light" data-id="element-197" data-mp="1x7869rdijxvp">
            {PRICE} ({PRICE_PLN}) &mdash; płatność jednorazowa, bez subskrypcji.
          </p>
          <div className="mt-2 flex flex-wrap justify-center gap-x-5 gap-y-2" data-id="element-198" data-mp="268y4bg1whv2g">
            {assurances.map(({
            icon: Icon,
            label
          }) => <span key={label} className="flex items-center gap-2 text-xs text-cream-muted" data-id="element-199" data-mp="2b2so0jhiaa1j">
                <Icon className="h-3.5 w-3.5 text-amber" aria-hidden="true" data-id="element-200" data-mp="2g1ww16sp21qa" />
                {label}
              </span>)}
          </div>
        </div>
      </div>
    </header>;
}